


















































































































import { validateFormulaSyntax } from "@/services/formula_validator";

export default {
  name: "CondFormatEditor",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    whenOptions: {
      type: Array,
      default() {
        return [
          { value: "below_min", text: this.$t("COND_FORMAT_WHEN_BELOW_MIN") },
          { value: "above_max", text: this.$t("COND_FORMAT_WHEN_ABOVE_MAX") },
          { value: "between", text: this.$t("COND_FORMAT_WHEN_BETWEEN") },
          { value: "equal", text: this.$t("COND_FORMAT_WHEN_EQUAL") },
          { value: "value_in_list", text: this.$t("COND_FORMAT_WHEN_VALUE_IN_LIST") },
        ];
      },
    },
    /** Initial expand state. Default true if there are rules. */
    initiallyExpanded: {
      type: Boolean,
      default: null,
    },
    /**
     * Traegt der Gegenstand, der hier bearbeitet wird, eigene Grenzwert-Formeln
     * (calcMinFormula/calcMaxFormula), auf die ein leeres Override-Feld
     * zurueckfallen kann? Formularfelder tun das, Tabellenspalten nicht: deren
     * Schema (cld-backend cl_table_columns.js) fuehrt die beiden Felder nicht,
     * und der Auswerter verwirft eine Regel ohne aufloesbare Grenze. Der
     * Default ist die vorsichtige Lesart — ein Aufrufer, der die Formeln hat,
     * sagt es ausdruecklich.
     */
    hasFieldLimitFormulas: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    minOverrideHintKey() {
      return this.hasFieldLimitFormulas
        ? "COND_FORMAT_MIN_OVERRIDE_HINT"
        : "COND_FORMAT_MIN_OVERRIDE_HINT_NO_FALLBACK";
    },
    maxOverrideHintKey() {
      return this.hasFieldLimitFormulas
        ? "COND_FORMAT_MAX_OVERRIDE_HINT"
        : "COND_FORMAT_MAX_OVERRIDE_HINT_NO_FALLBACK";
    },
  },
  data() {
    return {
      rules: [],
      expanded: false,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        // Sync working copy when parent updates `value`. Skip when the incoming
        // value is structurally identical to the current working copy — this
        // avoids the v-model ping-pong (parent → value → rules → emit → parent
        // → value …) that would otherwise lock the browser in a tight loop.
        const incomingJson = JSON.stringify(Array.isArray(newVal) ? newVal : []);
        const currentJson = JSON.stringify(this.rules || []);
        if (incomingJson === currentJson) return;
        this._syncingFromValue = true;
        this.rules = JSON.parse(incomingJson);
        if (this.initiallyExpanded === null) {
          this.expanded = this.rules.length > 0;
        } else {
          this.expanded = this.initiallyExpanded;
        }
        this.$nextTick(() => {
          this._syncingFromValue = false;
        });
      },
    },
    rules: {
      deep: true,
      handler(newVal) {
        // Skip emit when the change came from the value watcher above —
        // otherwise the parent would re-set value, retriggering this watcher.
        if (this._syncingFromValue) return;
        // Also skip if the new rules equal the current value structurally
        // (defensive: covers cases where the parent re-emits the same payload).
        const newJson = JSON.stringify(newVal || []);
        const valueJson = JSON.stringify(Array.isArray(this.value) ? this.value : []);
        if (newJson === valueJson) return;
        this.$emit("input", JSON.parse(newJson));
      },
    },
  },
  methods: {
    whenType(rule) {
      return (rule && rule.when && rule.when.type) || "below_min";
    },
    whenField(rule, key) {
      const raw = rule && rule.when ? rule.when[key] : "";
      return raw === undefined || raw === null ? "" : raw;
    },
    // Schreibt ueber $set: `when` kommt aus JSON.parse und traegt die Felder des
    // jeweiligen Typs oft noch nicht. Eine einfache Zuweisung waere auf einem
    // neuen Schluessel nicht reaktiv — der deep-Watcher auf `rules` liefe nicht,
    // und die Eingabe erreichte den Aufrufer nie.
    setWhenField(rule, key, val) {
      if (!rule.when) this.$set(rule, "when", {});
      this.$set(rule.when, key, val === undefined || val === null ? "" : val);
    },
    valueList(rule) {
      const list = rule && rule.when ? rule.when.valueList : null;
      return Array.isArray(list) ? list : [];
    },
    setValueList(rule, list) {
      if (!rule.when) this.$set(rule, "when", {});
      const clean = (Array.isArray(list) ? list : [])
        .filter((v) => v !== undefined && v !== null && String(v) !== "")
        .map((v) => String(v));
      this.$set(rule.when, "valueList", clean);
    },
    equalValue(rule) {
      const list = this.valueList(rule);
      return list.length > 0 ? String(list[0]) : "";
    },
    setEqualValue(rule, val) {
      const v = val === undefined || val === null ? "" : String(val);
      this.setValueList(rule, v === "" ? [] : [v]);
    },
    // Reine Syntaxpruefung mit dem bestehenden Validator. Die Variablenpruefung
    // (findUnknownVars) bleibt aussen vor: sie braucht die Geschwisterfelder der
    // Aufgabe, und dieser Editor laeuft auch im Spalten-Dialog, wo es die nicht gibt.
    formulaError(formula) {
      const result = validateFormulaSyntax(formula);
      return result.ok ? [] : [result.error];
    },
    showsMinOverride(rule) {
      const type = this.whenType(rule);
      return type === "below_min" || type === "between";
    },
    showsMaxOverride(rule) {
      const type = this.whenType(rule);
      return type === "above_max" || type === "between";
    },
    addRule() {
      this.rules.push({
        uid: "cf_" + Date.now() + "_" + Math.floor(Math.random() * 10000),
        when: { type: "below_min" },
        textColor: "",
        bold: false,
        italic: false,
        underline: false,
      });
    },
    removeRule(idx) {
      this.rules.splice(idx, 1);
    },
  },
};
